const isTest = document.domain.indexOf('flexclip.com') === -1;

const STORAGE_TYPE = {
    STANDARD: 'STANDARD',
    INTELLIGENT_TIERING: 'INTELLIGENT_TIERING', // 保存成智能分层
};

const FJS3Config = {
    BUCKET_REGION: isTest ? 'us-west-1' : 'us-west-2',
    IDENTITY_POOL_ID: isTest
        ? 'us-west-1:c5f35c2f-1ccf-4e23-8172-23fbb58415a5'
        : 'us-west-2:fcddaf98-e358-431a-a47f-6bdabd7b263d', // 正式版的media存储桶region是us-west-2
    ALBUM_BUCKET_NAME: isTest ? 'flexclip-test' : 'flexclip-media',
    STORAGE_TYPE: STORAGE_TYPE,
    S3_SERVER_HOST: isTest ? 'https://www.smartvideomaker.com/' : 'https://www.flexclip.com/',

    // s3 无缓存访问链接
    S3_NOT_CATCH_HOST: isTest
        ? 'https://flexclip-test.s3.us-west-1.amazonaws.com/'
        : 'https://flexclip-media.s3.us-west-2.amazonaws.com/',
};

export default FJS3Config;
